import { BaseService } from "@/script/core/service/BaseService";
import { Task } from "../entity/SystemEntity";

export class TaskService extends BaseService {
    public execute(task: Task): Promise<any> {
        return super.post("/api/sys/task/execute", task);
      }
}
